import Hogan from "hogan.js";
import jQuery from 'jquery';

;(function ( $, window, document, undefined ) {

    var pluginName = "scanAdminManager";
    var defaults = {
      "url" : zmp_ajax.ajaxurl,
    };


    function ScanAdminManager ( element, options ) {
      var _this = this;
      this.element = element;
      this.$element = $(this.element);
      this.settings = $.extend( {}, defaults, options );
      this.loading = false;
      this.$loadingdiv = this.settings.loadingdiv || $("<div class=\"loading hide\">Bezig met laden...</div>");
      this._defaults = defaults;
      this._name = pluginName;
      this.scan = {};
      this.scan_saved = {};
      this.current_chapter = 0;


      this.init();
    }

    $.extend(ScanAdminManager.prototype, {
      init: function () {
        var _this = this;
        this.template_chapter = Hogan.compile($ ( "#template_chapter" ).html());
        this.template_scan = Hogan.compile($ ( "#template_scan" ).html());
        this.getData();
      },
      getData : function () {
        var _this = this;
        $.ajax({
          url : this.settings.url,
          method : "GET",
          data : {
            "scan_id" : _this.$element.attr ("data-scan_id"),
            "action" : "zmpzt_get_scan"
          },
          dataType : "json",
          success : function(data) {

            if ("success" in data && data.success === false ){

            } else {
              _this.scan = _this.indexScanData(data.scan);
              _this.scan_saved = $.extend(true, {}, _this.scan);

              _this.renderScan();
            }

          }
        });
      },
      saveData : function () {
        var _this = this;
        $.ajax({
          url : this.settings.url,
          method : "POST",
          data : {
            "json" : JSON.stringify( {"scan" : this.scan } ),
            "action" : "zmpzt_save_scan"
          },
          dataType : "json",
          success : function(data) {

            if ("success" in data && data.success === false ){

            } else {
              // _this.scan = _this.indexScanData(data.scan);
              // _this.scan_saved = $.extend(true, {}, _this.scan);

              _this.getData();
            }

          }
        });
      },
      revert : function () {

        this.scan = $.extend(true, {}, this.scan_saved);

      },
      indexScanData : function (scan) {
        for ( var chapterIdx in scan.chapter ) {

          scan.chapter[chapterIdx].idx = parseInt(chapterIdx);
          scan.chapter[chapterIdx].idx1 = parseInt(chapterIdx)+1;

          for ( var adviceIdx in  scan.chapter[chapterIdx].advice ) {

             scan.chapter[chapterIdx].advice[adviceIdx].idx=parseInt(adviceIdx);
             scan.chapter[chapterIdx].advice[adviceIdx].idx1=parseInt(adviceIdx)+1;

          }

          for ( var questionIdx in  scan.chapter[chapterIdx].question ) {

             scan.chapter[chapterIdx].question[questionIdx].idx=parseInt(questionIdx);
             scan.chapter[chapterIdx].question[questionIdx].idx1=parseInt(questionIdx)+1;

          }

        }
        return scan;

      },
      rememberChange : function ( options, val ) {

        switch ( options.obj ) {

          case "scan" :

            this.scan [ options.prop ] = val;

          break;

          case "chapter" :

            this.scan.chapter [ options.idx_chapter ] [ options.prop ] = val;

          break;

          case "question" :

            this.scan.chapter [ options.idx_chapter ].question [ options.idx_question ] [ options.prop ] = val;

          break;

          case "advice" :

            this.scan.chapter[options.idx_chapter].advice[options.idx_advice][options.prop] = val;

            if ( options.prop === "score_max" ) {
              var old = val;
              for ( var i=options.idx_advice; i < 4; i++) {
                val = this.scan.chapter[options.idx_chapter].advice[ i ][options.prop];

                this.scan.chapter[options.idx_chapter].advice[ i ][options.prop] = Math.max( val,old );
                this.scan.chapter[options.idx_chapter].advice[ i+1 ].score_min = this.scan.chapter[options.idx_chapter].advice[ i ][options.prop];
                old = val;
              }
              this.renderChapter(options.idx_chapter);
            }


          break;

          case "feedback" :

            if (options.feedback_for == "chapter"){

              this.scan.chapter [ options.idx_chapter ].feedback [ options.prop ] = val;

            }else{

              this.scan.feedback [ options.prop ] = val;
            }

          break;
        }


      },
      render_chapter_list : function () {
        //var _this = this;
        return function(text) {
          var data: any = {};
          data.chapter = this.scan.chapter;
          data.lambdas = this.lambdas;

          return Hogan.compile($( "#template_chapter_list" ).html()).render(data);

        };
      },
      renderScan : function () {
        var _this = this;
        var data = {
          "scan" : _this.scan,
          "lambdas" : {
            "render_chapter_list" : _this.render_chapter_list,
            "render_chapter" : _this.render_chapter
          }
        };
        this.$element.html ( this.template_scan.render ( data ) );
        this.$element.trigger ( "rendered" );
      },
      renderChapter : function ( idx ) {
        var _this = this;
        var data = {
          "chapter" : _this.scan.chapter[idx],
        };
        data.chapter.chapterIdx = idx;
        data.chapter.lambdas = {
          "render_advice" : _this.render_advice,
          "render_question" : _this.render_question
        };

        this.$element.html ( this.template_chapter.render ( data ) );
        this.$element.trigger ( "rendered" );

      },
      newQuestion : function ( idxChapter ){
        this.getChapter( idxChapter ).question.push (
          {
            "title" : "",
            "min_label" : "",
            "max_label" : "",
            "not_applicable" : "",
            "next_question" : -1,
            "idx" : this.getChapter( idxChapter ).question.length,
            "idx1" : this.getChapter( idxChapter ).question.length+1,
            "curriculum" : [],
            "curriculum_meta" : []
          }
        );
        this.renderChapter( idxChapter );
      },
      removeQuestion : function ( idxChapter, idxQuestion ) {
        this.getChapter ( idxChapter ).question.splice( idxQuestion, 1 );
        this.scan=this.indexScanData(this.scan);

        this.renderChapter ( idxChapter );
      },
      moveQuestion : function ( idxChapter, idxQuestion, idxNew) {

        var one =  this.getQuestion( idxChapter, idxQuestion );
        var other =  this.getQuestion( idxChapter, idxNew );

        this.setQuestion ( idxChapter, idxNew, one );
        this.setQuestion ( idxChapter, idxQuestion, other );

        this.scan=this.indexScanData(this.scan);

        this.renderChapter ( idxChapter );

      },
      getQuestionCount : function ( idxChapter ) {

        return this.getChapter( idxChapter ).question.length;

      },

      getQuestion : function ( idxChapter, idxQuestion ) {

        return this.getChapter( idxChapter ).question[ idxQuestion ];

      },

      setQuestion : function ( idxChapter, idxQuestion, val ) {

        this.getChapter( idxChapter ).question[ idxQuestion ] = val;

      },

      getChapter : function ( idxChapter ) {

        return this.scan.chapter[ idxChapter ];

      },

      setCurrentChapterQuestion : function ( idxQuestion, data ) {

        this.getChapter( this.current_chapter ).question [ idxQuestion ] = data;

      },
      newChapter : function ( ){

        this.scan.chapter.push (
          {
            "title" : "",
            "description" : "",
            "color" : "",
            "advice" : [
              { "text" : "", "score_min" : 0, "score_max" : 2 },
              { "text" : "", "score_min" : 2, "score_max" : 4 },
              { "text" : "", "score_min" : 4, "score_max" : 6 },
              { "text" : "", "score_min" : 6, "score_max" : 8 },
              { "text" : "", "score_min" : 8, "score_max" : 10 }
            ],
            "feedback" : {
              "text" : "",
              "image" : ""
            },
            "question" : [],
            "idx" : this.scan.chapter.length,
            "idx1" : this.scan.chapter.length+1
          }
        );
        this.scan=this.indexScanData(this.scan);

        this.renderChapter( this.scan.chapter.length-1 );
      },
      destroy : function(){
        this.$element.empty();
        this.$element.data("plugin_"+pluginName,null);
        //delete this;
      },
      logmessage: function(message){
        if(this.settings.showDebug) console.log(message);
      }
    });

    $.fn[ pluginName ] = function ( methodOrOptions ) {

      var method = (typeof methodOrOptions === 'string') ? methodOrOptions : undefined;

      if (method) {
          var customPlugins: Array<any> = [];

          const getCustomPlugin = () => {
              var $el          = $(this);
              var customPlugin = $el.data("plugin_"+pluginName);

              customPlugins.push(customPlugin);
          }

          this.each(getCustomPlugin);

          var args    = (arguments.length > 1) ? Array.prototype.slice.call(arguments, 1) : undefined;
          var results: Array<any> = [];

          const applyMethod = (index)=> {
              var customPlugin = customPlugins[index];

              if (!customPlugin) {
                  console.warn('$.customPlugin not instantiated yet');
                  console.info(this);
                  results.push(undefined);
                  return;
              }

              if (method && typeof customPlugin[method] === 'function') {
                  var result = customPlugin[method].apply(customPlugin, args);
                  results.push(result);
              } else {
                  console.warn('Method \'' + method + '\' not defined in $.customPlugin');
              }
          }

          this.each(applyMethod);

          return (results.length > 1) ? results : results[0];
      } else {
          var options = (typeof methodOrOptions === 'object') ? methodOrOptions : undefined;

          const init= () => {
              var $el          = $(this);
              var customPlugin = new ScanAdminManager($el, options);

              $el.data("plugin_"+pluginName, customPlugin);
          }

          return this.each(init);
      }


    };

})( jQuery, window, document );
